import number from "@/data/number";

export default [
  {
    key: "onKey",
    label: "field.onKey",
    rules: "required",
    type: "single-selection",
    reduce: true,
    rows: "5",
    cols: 12,
    options: number,
  },
  {
    key: "voice",
    label: "field.voice",
    initKey: "voice",
    rules: "required",
    type: "single-audio",
    rows: "5",
    cols: 12,
  },
  {
    key: "command",
    label: "field.command",
    rules: "required",
    type: "single-selection",
    reduce: true,
    cols: 12,
    options: [
      {
        name: "option.tree",
        id: "tree",
      },
      {
        name: "option.call",
        id: "call",
      },
      {
        name: "option.no",
        id: "no",
      },
    ],
  },
  {
    key: "memo",
    label: "field.memo",
    rules: "required",
    type: "textarea",
    rows: "2",
    cols: 12,
  },
];
